const currentDate = new Date();

export const filterDatePeriods = [
	{
		startDate: new Date(
			currentDate.getFullYear(),
			currentDate.getMonth(),
			1
		),
		endDate: new Date(
			currentDate.getFullYear(),
			currentDate.getMonth() + 1,
			0
		),
		label: "currentMonth",
	},
	{
		startDate: new Date(
			currentDate.getFullYear(),
			currentDate.getMonth() - 1,
			1
		),
		endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 0),
		label: "lastMonth",
	},
	{
		startDate: new Date(currentDate.getFullYear(), 0, 1),
		endDate: new Date(currentDate.getFullYear(), 11, 31),
		label: "currentYear",
	},
];
